/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import { uniqBy, set } from 'lodash-es';

import {
  findBy,
} from '@/utils/activities';

// initial state
const state = {
  employee: {
    id: null,
    companyId: null,
    firstName: null,
    lastName: null,
    email: null,
  },
  subscriptionId: null,
  startDate: null,
  endDate: null,
  destination: null,
};

// getters
const getters = {
  get: (state) => state,
  subscriptionId: (state) => state.subscriptionId,
};

// actions
const actions = {

  /**
   ** Research a term in all countries
   * @param {String} term value to be researched in all countries list
   * @returns {Array{Object}} countries found in list
   */
  search(unset, { value, list }) {
    const keys = [
      {
        name: 'name',
        weight: 1,
      },
    ];
    // use of fuzzy search based on activity name
    return findBy(value, uniqBy(list, 'code'), keys);
  },
  setDestination({ commit }, country) {
    if (country === null) {
      commit('SET_DESTINATION', null);
    }
    commit('SET_DESTINATION', country);
  },
  clear({ commit }) { commit('CLEAR'); },
  setValue({ commit }, object) { commit('setValue', object); },
  setValueWithPath({ commit }, object) {
    if (object) {
      commit('SET_VALUE_WITH_PATH', object);
    }
  },
};

// mutations
const mutations = {
  CLEAR(state) {
    Object.assign(state, {
      employee: {
        companyId: null,
        firstName: null,
        lastName: null,
        email: null,
      },
      subscriptionId: null,
      startDate: null,
      endDate: null,
      destination: null,
    });
  },
  setValue(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
  SET_DESTINATION(state, country) {
    Object.assign(state, { destination: country });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
